import { render, staticRenderFns } from "./faturadetay.vue?vue&type=template&id=ff31105e&"
import script from "./faturadetay.vue?vue&type=script&lang=js&"
export * from "./faturadetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports